import React from "react";
import { Link } from "react-router-dom";
import classes from "./dashboard.module.scss";

const mobileQuickLinks = [
  {
    title: "Personal Details",
    path: "/user/profile",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    title: "Orders",
    path: "/my-orders",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
    ),
  },
  {
    title: "Wishlist",
    path: "/wishlists",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    title: "Addresses",
    path: "/user/profile",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 19.5A2.5 2.5 0 0 0 6.5 22h11A2.5 2.5 0 0 0 20 19.5V4.5A2.5 2.5 0 0 0 17.5 2h-11A2.5 2.5 0 0 0 4 4.5v15z" />
        <path d="M8 7h8" />
        <path d="M8 12h8" />
      </svg>
    ),
  },
];

const mobileActivityLinks = [
  {
    title: "FAQ",
    path: "/faq",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9.09 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
        <rect x="3" y="3" width="18" height="18" rx="2" />
      </svg>
    ),
  },
  {
    title: "Customer Service",
    path: "/customer-service",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 12v-2a8 8 0 0 1 16 0v2" />
        <rect x="1" y="12" width="4" height="6" rx="1" />
        <rect x="19" y="12" width="4" height="6" rx="1" />
        <path d="M21 18a2 2 0 0 1-2 2h-2a1 1 0 0 1 0-2h1" />
      </svg>
    ),
  },
  {
    title: "News",
    path: "/news",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4z" />
        <path d="M17 12h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" />
        <line x1="8" y1="8" x2="12" y2="8" />
        <line x1="8" y1="12" x2="12" y2="12" />
        <line x1="8" y1="16" x2="11" y2="16" />
      </svg>
    ),
  },
];

const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const getProfileName = (profileData) => {
  const firstName =
    profileData && profileData.first_name ? profileData.first_name : "";
  const lastName =
    profileData && profileData.last_name ? profileData.last_name : "";
  const combinedName = `${firstName} ${lastName}`.trim();
  return (profileData && profileData.name) || combinedName || "My Account";
};

const MobileDashboard = ({ profile_data, actUserLogout }) => {
  const profileName = getProfileName(profile_data);
  const profileEmail = (profile_data && profile_data.email) || "";
  const avatarInitial = (profileName || profileEmail || "A")
    .charAt(0)
    .toUpperCase();

  return (
    <div className={classes.mobile_home}>
      <div className={classes.mobile_profile}>
        <div className={classes.avatar}>{avatarInitial}</div>
        <p className={classes.mobile_name}>{profileName}</p>
        {profileEmail ? (
          <p className={classes.mobile_email}>{profileEmail}</p>
        ) : null}
      </div>

      <div className={classes.mobile_quick_grid}>
        {mobileQuickLinks.map((item) =>
          item.path ? (
            <Link
              key={item.title}
              to={`${process.env.PUBLIC_URL}${item.path}`}
              className={classes.quick_card}
            >
              <span className={classes.quick_icon}>{item.icon}</span>
              <span className={classes.quick_label}>{item.title}</span>
            </Link>
          ) : (
            <div
              key={item.title}
              className={`${classes.quick_card} ${classes.disabled_item}`}
              aria-disabled="true"
            >
              <span className={classes.quick_icon}>{item.icon}</span>
              <span className={classes.quick_label}>{item.title}</span>
            </div>
          ),
        )}
      </div>

      <div className={classes.mobile_activity}>
        <h3 className={classes.activity_title}>My Activity</h3>
        <div className={classes.activity_list}>
          {mobileActivityLinks.map((item) =>
            item.path ? (
              <Link
                key={item.title}
                to={`${process.env.PUBLIC_URL}${item.path}`}
                className={classes.activity_item}
              >
                <span className={classes.activity_left}>
                  <span className={classes.activity_icon}>{item.icon}</span>
                  <span className={classes.activity_label}>{item.title}</span>
                </span>
                <span className={classes.activity_arrow}>
                  <ArrowIcon />
                </span>
              </Link>
            ) : (
              <div
                key={item.title}
                className={`${classes.activity_item} ${classes.disabled_item}`}
                aria-disabled="true"
              >
                <span className={classes.activity_left}>
                  <span className={classes.activity_icon}>{item.icon}</span>
                  <span className={classes.activity_label}>{item.title}</span>
                </span>
                <span className={classes.activity_arrow}>
                  <ArrowIcon />
                </span>
              </div>
            ),
          )}

          <button
            type="button"
            className={`${classes.activity_item} ${classes.activity_button}`}
            onClick={actUserLogout}
          >
            <span className={classes.activity_left}>
              <span className={classes.activity_icon}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </span>
              <span className={classes.activity_label}>Logout</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileDashboard;
